import { useNavigate } from "react-router-dom";
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { useEffect, useState } from "react";
import { submitImpactForm } from "../../../services";
import { getImpactForm } from "../../../services/autofillService";
import { Formik, Form, Field, FieldArray } from "formik";
import { Step } from "../../../components/Step/Step";
import { getClassName } from "../../../utils";
import { questions, videos } from "../../../content/purpose/impact";
import { TextareaAutosize } from "@mui/material";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { UpButton } from "../../../components/Buttons/UpButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { Oval } from "react-loader-spinner";
import { submitImpact } from "../../../services/answersService";

export const PurposeImpact = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0)
    const [initialValues, setInitialValues] = useState({
        impactBenefit1: [
            {
                impactBenefit: ''
            },
        ],
        impactBenefit2: [
            {
                impactBenefit: ''
            },
        ],
        combine: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (values) => {
        setIsLoading(true);
        submitImpact(values).then(response => {
            setIsLoading(false);
            navigate("/flow/purpose/product")
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        });
    }

    const handleUpClick = () => {
        setActiveStep(activeStep - 1);
        if (activeStep === 2) {
            dispatch(setProgress(33))
        } else if (activeStep === 1) {
            dispatch(setProgress(30))
        }
    }

    const handleDownClick = () => {
        setActiveStep(activeStep + 1);
        if (activeStep === 0) {
            dispatch(setProgress(33));
        } else if (activeStep === 1) {
            dispatch(setProgress(36));
        }
    }

    const combineInformation = (values) => (
        <div className="flex gap-3 flex-1">
            <div className="flex flex-col gap-2">
                <p className="text-light-grey text-sm">Previous Impact/Benefits:</p>
                <ul className="flex-1">
                    {values.impactBenefit1.map((el, index) => (
                        <li className="text-light-grey text-sm" key={index}>
                            {el.impactBenefit}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="flex flex-col gap-2">
                <p className="text-light-grey text-sm">Updated Impact/Benefits:</p>
                <ul className="flex-1">
                    {values.impactBenefit2.map((el, index) => (
                        <li className="text-light-grey text-sm" key={index}>
                            {el.impactBenefit}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )

    useEffect(() => {
        dispatch(setProgress(30))
        getImpactForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.error(err);
        })
    }, []);
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <>
                            <Form className="w-full max-w-[35%] h-full relative flex flex-col items-start justify-center">
                                <section className="flex flex-col items-center justify-center w-full h-full">
                                    <Step className={getClassName(0, activeStep)} question={questions.impactBenefit1} url={videos.impactBenefit1Video.url}>
                                        <FieldArray name="impactBenefit1">
                                            {({ insert, remove, push }) => (
                                                <>
                                                    {values.impactBenefit1.length > 0 &&
                                                        values.impactBenefit1.map((impactBenefit, index) => (
                                                            <Field
                                                                name={`impactBenefit1.${index}.impactBenefit`}
                                                                placeholder="Impact or Benefit"
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                                as={TextareaAutosize}
                                                            />
                                                        ))
                                                    }
                                                    <AddMore onClick={() => push({ impactBenefit: '' })} />
                                                </>
                                            )}
                                        </FieldArray>
                                    </Step>
                                    <Step className={getClassName(1, activeStep)} question={questions.impactBenefit2} url={videos.impactBenefit2Video.url}>
                                        <FieldArray name="impactBenefit2">
                                            {({ insert, remove, push }) => (
                                                <>
                                                    {values.impactBenefit2.length > 0 &&
                                                        values.impactBenefit2.map((impactBenefit, index) => (
                                                            <Field
                                                                name={`impactBenefit2.${index}.impactBenefit`}
                                                                placeholder="New Impact or Benefit"
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                                as={TextareaAutosize}
                                                            />
                                                        ))}
                                                    <AddMore onClick={() => push({ impactBenefit: '' })} />
                                                </>
                                            )}
                                        </FieldArray>
                                    </Step>
                                    <Step
                                        className={getClassName(2, activeStep)}
                                        question={questions.combine}
                                        url={videos.combineVideo.url}
                                        information={combineInformation(values)}
                                    >
                                        <Field
                                            name="combine"
                                            placeholder="The main benefit people will get."
                                            className="has-border-bottom mt-3"
                                            as={TextareaAutosize}
                                        />
                                    </Step>
                                </section>
                                <Buttons link="/flow/purpose/people">
                                    <UpButton onClick={handleUpClick} disabled={activeStep === 0} />
                                    {(activeStep === 2) ? (
                                        <button type="submit" className="btn yellow-cta">
                                            {isLoading ? <Oval
                                                height={30}
                                                width={50}
                                                color="black"
                                                secondaryColor="black"
                                            /> : (
                                                <span>
                                                    Next
                                                </span>
                                            )}
                                        </button>
                                    ) : (
                                        <DownButton onClick={handleDownClick} disabled={activeStep === 2} />
                                    )}
                                </Buttons>
                            </Form>
                        </>
                    )}
                </Formik>
            </section>
            <HeaderSidebar activeEl="Purpose" />
        </>
    )
}